import { TopBannerMessage } from '@post-office/jira-common/components/top-banner-message';

import { createRender } from './types';

export const render = createRender(() => <TopBannerMessage />);

export default render;
